$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
Browser = require '@trello/browser'
config = require '@trello/config'
errorMemory = require './error-memory'

module.exports = (error, url, line, col, tags) ->
  versionParts = config.clientVersion.split('-')
  head = versionParts.slice(0, -1).join('-')
  version = versionParts.slice(-1)[0]
  version = parseInt(version, 10)
  clientVersion = { head, version, patch: 0 }

  entry = {
    name: error.name
    msg: error.message
    url
    line
    col
    stack: error.stack
    ua: navigator.userAgent
    browser: Browser.asString
    isBrowserSupported: Browser.isBrowserSupported()
    language: navigator.language ? navigator.browserLanguage
    clientVersion
    tags: Object.assign(
      { isBrowserSupported: Browser.isBrowserSupported() }
      tags
    )
  }

  if Auth.isLoggedIn()
    entry.idMember = Auth.myId()

  try
    $.post('/err', { errors: [entry] })
    errorMemory.add {
      timestamp: (new Date()).toISOString()
      stack: error.stack
      name: error.name
      msg: error.message
      url
    }
  catch ex

  return
